import * as THREE from 'three';
import CANNON from 'cannon';
import gsap from 'gsap';

const DEFAULT_POSITION = new THREE.Vector3(0, 0, 0);

export default class SectionBillboard {
  constructor({ scene, resources, objects, physics, debug, areas, rotateX = 0, rotateY = 0, rotateZ = 0, camera = 0, time = 0, car = null, passes, zones }) {
    this.scene = scene;
    this.resources = resources;
    this.objects = objects;
    this.physics = physics;
    this.debug = debug;
    this.areas = areas;
    this.camera = camera
    this.passes = passes;
    this.zones = zones;

    this.rotateX = rotateX;
    this.rotateY = rotateY;
    this.rotateZ = rotateZ;

    this.time = time;

    this.car = car;

    this.container = new THREE.Object3D();
    this.position = DEFAULT_POSITION.clone();
    
    this.billboards = [
      { position: { x: 3 , y: -8, z: 0 }, name: "Billboard1", link: "https://gokonya.com/en/catalhoyuk" },
      { position: { x: 14, y: -8, z: 0 }, name: "Billboard2", link: "https://kbbgenclikmeclisi.com/hosgeldin" },
      { position: { x: 23, y: -7, z: 0 }, name: "Billboard3", link: "https://www.genckultur.com/" },
      { position: { x: 32, y: -1.5, z: 0 }, name: "Billboard4", link: "https://gokonya.com/tr/karatay-medresesi" },
      { position: { x: 43, y: 0, z: 0 }, name: "Billboard5", link: "https://gokonya.com/en/mevlana" },
      { position: { x: 53, y: 1, z: 0 }, name: "Billboard6", link: "https://gokonya.com/en/sille-2" }
    ];

    // Her bir billboard için model oluştur
    this.billboards.forEach((billboard) => {
      this._buildModel(billboard.position, billboard.name);
      this.createButton(billboard.position, billboard.link);
    });

    this.scene.add(this.container);
    this.setZones()
  }

  _buildModel(position, name) {
    const gltf = this.resources.items[name];
    const base = this.resources.items.Base;
  
    if (!gltf || !gltf.scene) {
      console.error('SectionBillboard bina modeli bulunamadı');
      return;
    }
  
    if (!base || !base.scene) {
      console.error('Base modeli bulunamadı');
      return;
    }
  
    // Division modelini klonla ve malzemeleri kopyala
    const model = gltf.scene.clone(true);
    model.traverse(child => {
      if (child.isMesh) {
        const origMat = child.material;
        const mat = origMat.clone();
        if (origMat.map) mat.map = origMat.map;
        if (origMat.normalMap) mat.normalMap = origMat.normalMap;
        if (origMat.roughnessMap) mat.roughnessMap = origMat.roughnessMap;
        if (origMat.metalnessMap) mat.metalnessMap = origMat.metalnessMap;
        mat.needsUpdate = true;
        child.material = mat;
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  
    // Base modelini klonla ve Kapsül modeline ekle
    const baseModel = base.scene.clone(true);
    baseModel.position.set(0 + position.x, 0 + position.y, 0 + position.z); // Pozisyonu ayarla
    baseModel.scale.set(1, 1, 1); // Base modelinin ölçeği
    //this.container.add(baseModel);
   
    // Kapsül model pozisyonu ve dönüşü
    const modelPosition = new THREE.Vector3(position.x, position.y, position.z);
    model.position.copy(modelPosition);
    model.rotation.set(this.rotateX, this.rotateY, this.rotateZ + -Math.PI/2);
    this.container.add(model);
   
    // Bounding box hesapla
    baseModel.updateMatrixWorld(true);
    const bbox = new THREE.Box3().setFromObject(model);
    var size = bbox.getSize(new THREE.Vector3());
   
    // Fizik gövdesi oluştur
    const halfExtents = new CANNON.Vec3(size.x / 3, size.y / 3, size.z);
    const boxShape = new CANNON.Box(halfExtents);
   
    const body = new CANNON.Body({
      mass: 0,
      position: model.position,
      material: this.physics.materials.items.floor
    });
  
    // Dönüşü quaternion olarak ayarla
    const quat = new CANNON.Quaternion();
    quat.setFromEuler(this.rotateX, this.rotateY, this.rotateZ + -Math.PI/2, 'XYZ');
    body.quaternion.copy(quat);
  
    body.addShape(boxShape);
    this.physics.world.addBody(body);
  
    // Obje sistemine ekle
    if (this.objects) {
      const children = model.children.slice();
      const objectEntry = this.objects.add({
        base: { children },
        collision: { children },
        offset: new THREE.Vector3(position.x, position.y, position.z),
        mass: 0
      });
      objectEntry.collision = { body };
      if (objectEntry.container) {
        this.container.add(objectEntry.container);
      }
    }
  }

  createButton(billboardPosition, billboardLink) {
    // Etkileşimli buton oluştur
    this.button = {}
    
    // Buton konumu - ses odası için uygun konum
    this.button.position = new THREE.Vector3(
      billboardPosition.x , // Modelin önünde
      billboardPosition.y - 4,
      billboardPosition + 0.25 // Zemin üzerinde, görünür olacak şekilde
    )
    
    // Buton konteyneri
    this.button.container = new THREE.Object3D()
    this.button.container.position.copy(this.button.position)
    this.container.add(this.button.container)
    
    // Label
    this.button.label = {}
    this.button.label.size = 2
    this.button.label.geometry = new THREE.PlaneGeometry(this.button.label.size, this.button.label.size / 2.5, 1, 1)
    
    // Canvas ile texture oluştur
    this.button.label.canvas = document.createElement('canvas')
    this.button.label.canvas.width = 512
    this.button.label.canvas.height = 360
    this.button.label.context = this.button.label.canvas.getContext('2d')

    // Texture oluştur
    this.button.label.texture = new THREE.Texture(this.button.label.canvas)
    this.button.label.texture.magFilter = THREE.LinearFilter
    this.button.label.texture.minFilter = THREE.LinearFilter
    this.button.label.texture.needsUpdate = true
    
    // Materyal oluştur
    this.button.label.material = new THREE.MeshBasicMaterial({ 
        map: this.button.label.texture,
        transparent: true,
        opacity: 1.0,
        depthWrite: false,
    })
    
    // Mesh oluştur - Zemine dik konumlandır
    this.button.label.mesh = new THREE.Mesh(this.button.label.geometry, this.button.label.material)
    this.button.label.mesh.position.z = 0.15
    this.button.label.mesh.matrixAutoUpdate = false
    this.button.label.mesh.updateMatrix()
    
    // Konteynere ekle
    this.button.container.add(this.button.label.mesh)
    
    // Alan tetikleyici oluştur
    this.button.triggerArea = this.areas.add({
        position: new THREE.Vector2(this.button.position.x, this.button.position.y),
        halfExtents: new THREE.Vector2(2, 1.5),
        hasKey: true,
        testCar: true,
        active: true,
        car: this.car,
        billboardLink: billboardLink,
        isBillboard : true,
        areaSize: 3
    })
  }

  setZones() {
    this.billboards.forEach(billboard => {
      const zone = this.zones.add({
        position: {x: billboard.position.x, y : billboard.position.y + 2},
        halfExtents: {x: 4, y: 2},
      })

      zone.on('in', (_data) => {
        this.camera.angle.set('projects')
        gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: 0, duration: 2 })
        gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: 0, duration: 2 })
      })
  
      zone.on('out', () => {
        this.camera.angle.set('default')

      })
    });


  }
}